module.exports = __webpack_public_path__ + "static/media/logo.1af65df7.png";